import { stateMe } from '$states/me.svelte';
import { UserType } from '$types/userType';
import { Guard, type GuardRun } from '../utils/Guard';

export class AccessCircles extends Guard implements GuardRun {
  run() {
    if (this.target === '/circles' && stateMe.onboarding()) {
      // Users with INVITE type who haven't accepted an invite should go to onboard
      if (stateMe.current?.type === UserType.INVITE && !stateMe.current?.acceptedInviteTimestamp) {
        return this.redirectTo('/circles/onboard');
      }

      // Other onboarding users (SIGNUP, UNKNOWN, etc.) who haven't completed onboarding
      if (
        stateMe.current &&
        stateMe.current.type !== UserType.HUMAN &&
        !localStorage.getItem('went_through_circles_onboard_success')
      ) {
        return this.redirectTo('/circles/onboard');
      }
    }

    // Prevent dead loop: Set flag for users who should have access to /circles
    // This includes HUMAN users and INVITE users who have accepted invites
    if (
      this.target === '/circles' &&
      (!stateMe.onboarding() ||
        (stateMe.current?.type === UserType.INVITE && stateMe.current?.acceptedInviteTimestamp))
    ) {
      localStorage.setItem('went_through_circles_onboard_success', 'true');
    }
  }
}
